import React, { useMemo, useCallback, useImperativeHandle, useEffect, useState, useRef, useContext } from 'react';
import Form, { ButtonItem, EmptyItem, FormRef, GroupItem, Item, Label, SimpleItem } from 'devextreme-react/form';
import { AssistitiApi } from '../../data';
import { apiConfiguration } from '../../apiConfig';
import { FieldDataChangedEvent } from 'devextreme/ui/form';
import { ClickEvent } from 'devextreme/ui/button';
import { LoadPanel, ScrollView } from 'devextreme-react';
import TenantContext from '../../contexts/tenantContext';
import { showError } from '../../utils/errorHandling';
import { useDeambulazioneTipiDataSource } from '../../datasources/DeambulazioneTipiDataSource';
import { useDeambulazioneAusiliDataSource } from '../../datasources/DeambulazioneAusiliDataSource';

type Props = {
  assistitoId: string;
  onchanged?: () => void;
  readOnly?: boolean;
}

export type AssistitoEditAnamnesiPanelHandle = {
}

const AssistitoEditAnamnesiPanel: React.ForwardRefRenderFunction<AssistitoEditAnamnesiPanelHandle, Props> = (props, ref) => {
  const { currentTenant } = useContext(TenantContext);
  const [loadPanelVisible, setLoadPanelVisible] = useState<boolean>(false);
  const [formData, setFormData] = useState<any>();
  const formRef = useRef<FormRef>(null);

  const deambulazioneTipoIdProps ={
    dataSource: useDeambulazioneTipiDataSource(), 
    valueExpr:"id", 
    displayExpr: "descrizione", 
    showClearButton:true
  };

  const deambulazioneAusilioIdProps ={
    dataSource: useDeambulazioneAusiliDataSource(), 
    valueExpr:"id", 
    displayExpr: "descrizione", 
    showClearButton:true
  }

  useEffect(() => {
    setFormData(null);

    (async function () {
      const api = new AssistitiApi(apiConfiguration);
      setLoadPanelVisible(true);
      setFormData(await api.getFisiologicaGenerale({ tenantId: currentTenant.Id, assistitoId: props.assistitoId }));
      setLoadPanelVisible(false);
    })();

  }, [props.assistitoId]);

  function onFieldDataChanged(e: FieldDataChangedEvent) {
    // if (e.dataField==="dataDocumento" && e.component.getEditor('dataOperazione')?.option('value')==null){
    //     e.component.updateData("dataOperazione", e.value);
    // }   
  }

  function save_click(e: ClickEvent) {
    var validate = formRef.current?.instance().validate();

    if (validate?.isValid) {
      const api = new AssistitiApi(apiConfiguration);

      var data = formRef.current?.instance().option("formData");

      setLoadPanelVisible(true);
      api.updateFisiologicaGenerale({
        tenantId: currentTenant.Id,
        assistitoId: props.assistitoId,
        fisiologicaGeneraleDTO: data
      })
        .then(props.onchanged)
        .catch(showError)
        .finally(() => setLoadPanelVisible(false));

    }
  }

  return (
    <React.Fragment>
            {/* <ScrollView      >      */}
      <Form id="form" ref={formRef} colCount={1} formData={formData} onFieldDataChanged={onFieldDataChanged} labelMode='floating' readOnly={props.readOnly}>
      <GroupItem caption="Deambulazione" colCount={2} >
          <Item dataField="deambulazioneTipoId" editorType='dxSelectBox' isRequired={false} editorOptions={deambulazioneTipoIdProps} >
            <Label text="Tipo" />
          </Item>
          <Item dataField='deambulazioneAusilioId' editorType='dxSelectBox' isRequired={false} editorOptions={deambulazioneAusilioIdProps}>
            <Label text="Ausilio" />
          </Item>
          <Item dataField="deambulazioneNote" colSpan={2}  editorType='dxTextArea'>
            <Label text="Note" />
          </Item>
        </GroupItem>

        <GroupItem caption="Udito" colCount={2}>
          <Item dataField="uditoAssenza" colSpan={2} editorType='dxCheckBox' >
            <Label text="Assenza completa" />
          </Item>
          <Item dataField="uditoPatologiaOcchie" colSpan={2} editorType='dxTextArea'>
            <Label text="Patologia entrambe le orecchie" />
          </Item>
          <Item dataField="uditoPatologiaOrecchioSinistro" editorType='dxTextArea'>
            <Label text="Patologia orecchio sinistro" />
          </Item>
          <Item dataField="uditoPatologiaOrecchioDestro" editorType='dxTextArea'>
            <Label text="Patologia orecchio destro" />
          </Item>
          <Item dataField="uditoNote" colSpan={2}  editorType='dxTextArea'>
            <Label text="Note" />
          </Item>
        </GroupItem>

        <GroupItem caption="Visione" colCount={2}>
          <Item dataField="visioneAssenza" colSpan={2} editorType='dxCheckBox' >
            <Label text="Assenza completa" />
          </Item>
          <Item dataField="visionePatologiaOcchi" colSpan={2} editorType='dxTextArea'>
            <Label text="Patologia entrambi gli occhi" />
          </Item>
          <Item dataField="visionePatologiaOcchioSinistro" editorType='dxTextArea'>
            <Label text="Patologia occhio sinistro" />
          </Item>
          <Item dataField="visionePatologiaOcchioDestro" editorType='dxTextArea'>
            <Label text="Patologia occhio destro" />
          </Item>
          <Item dataField="visioneNote" colSpan={2}  editorType='dxTextArea'>
            <Label text="Note" />
          </Item>
        </GroupItem>

        <GroupItem caption="Medico SSN"  colCount={3}>
          <Item dataField="medicoSSNNome" editorType='dxTextBox' isRequired={false} >
            <Label text="Nome" />
          </Item>
          <Item dataField="medicoSSNCognome" editorType='dxTextBox' isRequired={false} >
            <Label text="Cognome" />
          </Item>
          <Item dataField="medicoSSNCitta" editorType='dxTextBox' isRequired={false} >
            <Label text="Città" />
          </Item>
          <Item dataField="medicoSSNTelefono" editorType='dxTextBox' isRequired={false} >
            <Label text="Telefono" />
          </Item>
          <Item dataField="medicoSSNCellulare" editorType='dxTextBox' isRequired={false} >
            <Label text="Cellulare" />
          </Item>
          <Item dataField="medicoSSNEmail" editorType='dxTextBox' isRequired={false} >
            <Label text="Email" />
          </Item>
          <Item dataField="medicoSSNNote" editorType='dxTextArea' isRequired={false} colSpan={3} >
            <Label text="Note" />
          </Item>
        </GroupItem>

        <GroupItem caption="Altro" colCount={1}>
          <Item dataField="altroOssigeno"  editorType='dxTextArea' >
            <Label text="Ossigeno" />
          </Item>
          <Item dataField="altroNote"  editorType='dxTextArea'>
            <Label text="Note" />
          </Item>
        </GroupItem>

        <ButtonItem horizontalAlignment="right" visible={!props.readOnly}
          buttonOptions={{
            text: 'Salva',
            type: 'default',
            icon: 'save',
            onClick: save_click
          }}
        />
      </Form>
      {/* </ScrollView> */}
      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        position={{ of: '#form' }}
        visible={loadPanelVisible}
        showIndicator={true}
        shading={false}
        showPane={true}
        hideOnOutsideClick={false}
      />
    </React.Fragment>
  );
}

export default React.forwardRef(AssistitoEditAnamnesiPanel);